import SelectProps from './SelectProps';
import { SelectedListProperty } from '../enums';

const SelectedListProps = {
  props: {
    [SelectedListProperty.Value]: SelectProps.props.Value,
    [SelectedListProperty.ColorScheme]: SelectProps.props.ColorScheme,
    [SelectedListProperty.Options]: SelectProps.props.Options,
  },
};

export default SelectedListProps;
